import React, { useState, useEffect, useRef } from "react";
import DashboardLayout from '../layouts/DashboardLayout'
import EsriFooter from '../components/EsriFooter'
import Textarea from '../components/Textarea'
// import Button from '../components/Button'
import DashboardHeader from '../components/DashboardHeader'
import { NavLink } from 'react-router-dom'
import { usePost } from "../libs/service/api";
import useFormValidation from "../libs/validation/formvalidation";
import ValidateAuth from "../libs/validation/feedback-validation";
import Alert from "../components/Alert";
import { useHistory } from "react-router-dom";
const Feedback = (props) => {
    const { toast, snackbar } = require('tailwind-toast')
    // const history = useHistory();
    const [showAlert, setShowAlert] = useState(false)
    const [isSending, setIsSending] = useState(false);
    const [isSucess, setIsSucess] = useState(false);
    const INITIAL_STATE = {
        answer1: "",
        answer2: "",
        answer3: ""
    };
    const formele = useRef();
    const OnSuccess = () => {

        setIsSending(true)
        usePost('/commonapi/userfeedback',
            [{
                key: "answer1",
                value: values.answer1
            }, {
                key: "answer2",
                value: values.answer2
            }, {
                key: "answer3",
                value: values.answer3
            }]).then(res => {
                setIsSucess(true)
                setIsSending(false)
                setTimeout(
                    function () {
                        setIsSucess(false)
                    }
                        .bind(this),
                    3000
                );
                // toast().success('', 'Feeeback Submited Sucessfully').with({
                //     shape: 'square',
                //     duration: 2000,
                //     speed: 200,
                //     positionX: 'end',
                //     positionY: 'top',
                //     color: 'text-white bg-primary border-primary-dark border rounded-lg',
                //     fontColor: 'white',
                //     fontTone: 0
                // }).show()
                document.querySelector("#answer1").value = ""
                document.querySelector("#answer2").value = ""
                document.querySelector("#answer3").value = ""
            });
    }

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        errors,
        isSubmitting
    } = useFormValidation(INITIAL_STATE, ValidateAuth, OnSuccess);

    useEffect(() => {

    }, []);
    return (
        <DashboardLayout hideAccountDropdown={true}>

            {showAlert && <Alert type="secondary" heading="Feedback" content="Feedback Submited Successfully" isVisible={true} />}
            <DashboardHeader title="Connect with us">
                <NavLink to="/connect/contact-us" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Contact Us</NavLink>
                <NavLink to="/connect/feedback" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Feedback</NavLink>
                <NavLink to="/connect/participate-in-workshop" className="mx-3 xl:mx-8" activeClassName="font-bold text-primary">Participate in Workshop</NavLink>
            </DashboardHeader>
            <div className="mt-12">
                <h2 className="text-xle font-bold mb-1">How can we make the tool better?</h2>
                <p>Please offer your suggestions.</p>
                <form id="feedbackform" className="account-form" onSubmit={handleSubmit} ref={formele}>
                    <div className="mt-10">
                        <Textarea id="answer1" onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.answer1} labelColor="black" label="1. Did the tool match all possible product or service offerings for your needs?"
                            placeholder="If not, please expand on what additional offerings we can add." name="answer1" />
                    </div>
                    <div className="mt-8">
                        <Textarea id="answer2" onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.answer2} labelColor="black" label="2. Is the tool intuitive to operate?" placeholder="Please expand on what more can we do to make it more user friendly." name="answer2" />
                    </div>
                    <div className="mt-8">
                        <Textarea id="answer3" onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.answer3} labelColor="black" label="3. Do you have a great idea that would make the tool function better? " placeholder="Type your genius ideas here." name="answer3" />
                    </div>
                    {isSucess && <div className=" bg-primary text-white border-bg-primary-light rounded-md border px-8 py-4 inline-flex">
                        Message has been successfully sent
                    </div>}
                    <div className="mt-6">

                        {!isSending && (<button type="submit" className="bg-primary hover:bg-primary-dark border-primary text-white  font-semibold  text-base py-1.5 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none px-20" >Send</button>)}

                        {isSending && (
                        <button type="submit" className="bg-primary hover:bg-primary-dark border-primary text-white  font-semibold  text-base py-1.5 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none px-20" >
                             <svg className="2xl:block animate-spin -ml-1 mr-1 h-5 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </button> 
                        )}
                    </div>
                </form>
            </div>

            <EsriFooter />
        </DashboardLayout>
    )
}


export default Feedback
